// extracted by mini-css-extract-plugin
module.exports = {"container":"_1SMl3i","title":"_2lBAuT","button":"QRlSwT","section":"_2GLy6k","input":"_1X7nz7"};